import {
  LIST_BULK_SMS_ERROR,
  LIST_BULK_SMS_START,
  LIST_BULK_SMS_SUCCESS,
} from 'constants/action-types/organizations/bulkSmsList';

export default (state, { type, payload }) => {
  switch (type) {
    case LIST_BULK_SMS_START:
      return {
        ...state,
        bulkSmsList: {
          ...state.bulkSmsList,
          loading: true,
        },
      };
    case LIST_BULK_SMS_ERROR:
      return {
        ...state,
        bulkSmsList: {
          ...state.bulkSmsList,
          error: payload,
          loading: false,
        },
      };
    case LIST_BULK_SMS_SUCCESS:
      return {
        ...state,
        bulkSmsList: {
          ...state.bulkSmsList,
          data: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
